<script>
  import { fade } from "svelte/transition";
  import { conversion, lang } from "../../store/store";
  import { onMount } from "svelte";
  import { db, user } from "../../firebase.js";
  import { baseAPIUrl } from "../../globals";
  import { doc, getDoc } from "firebase/firestore";
  import { disableNetwork } from "@firebase/firestore";
  let info = [];

  let packages_acc = {};
  $user.doc.subscribe(async (v) => {
    console.log({ v });
    if (v) {
      // packages_acc = $doc.stripe;
      // let Packages = [
      //   {
      //     name: $conversion[$lang].landing.pricing.packages.package1.title,
      //     hrs: packages_acc.package1.unit,
      //     price: packages_acc.package1.price,
      //     prod_id: packages_acc.package1.prod_id,
      //     desc: $conversion[$lang].landing.pricing.packages.package1
      //       .description,
      //     ctnColor: "#36B37E",
      //     hrsColor: "#2C8F73",
      //     startbgColor: "#FFFFFF",
      //     startColor: "#2C8F73",
      //     startborderColor: "#2C8F73",
      //   },
      //   {
      //     name: $conversion[$lang].landing.pricing.packages.package2.title,
      //     hrs: packages_acc.package2.unit,
      //     price: packages_acc.package2.price,
      //     prod_id: packages_acc.package2.prod_id,
      //     desc: $conversion[$lang].landing.pricing.packages.package2
      //       .description,
      //     ctnColor: "#FFD400",
      //     hrsColor: "#FFD400",
      //     startbgColor: "#FFFFFF",
      //     startColor: "#2C8F73",
      //     startborderColor: "#2C8F73",
      //   },
      //   {
      //     name: $conversion[$lang].landing.pricing.packages.package3.title,
      //     hrs: packages_acc.package3.unit,
      //     price: packages_acc.package3.price,
      //     prod_id: packages_acc.package3.prod_id,
      //     desc: $conversion[$lang].landing.pricing.packages.package3
      //       .description,
      //     ctnColor: "#1565D8",
      //     hrsColor: "#2E294E",
      //     startbgColor: "#2E294E",
      //     startColor: "#FFFFFF",
      //     startborderColor: "#2E294E",
      //   },
      // ];
    }
  });

  let resp;
  console.log(packages_acc);
  onMount(async () => {
    resp = await getDoc(
      doc(db, "/stores/" + user.auth.claims.store + "/secrets/protected")
    );

    let data = resp.data();
    let k = data.availableHrs;
    console.log("available hrs " + k);
    let output = "";
    let hrs = k / 60;
    if (hrs <= 0) {
      hrs = Math.ceil(hrs);
    } else {
      hrs = Math.floor(hrs);
    }
    console.log(hrs);
    if (hrs != 0) {
      output = hrs + " " + $conversion[$lang].landing.stats.stat2.hour + " ";
    }
    console.log(k);
    let minutes = Math.abs(k) - Math.abs(hrs) * 60;
    if (minutes != 0) {
      output =
        output + minutes + " " + $conversion[$lang].landing.stats.stat2.minutes;
    }
    if (minutes == 0 && hrs == 0) {
      output = "0 " + $conversion[$lang].landing.stats.stat2.minutes;
    }

    info = [
      {
        type: $conversion[$lang].landing.stats.stat2.title,
        quantity: output,
        txt: $conversion[$lang].landing.stats.stat2.description,
        bgcolor: "#012249",
        color: "#FFFFFF",
      },
      {
        type: $conversion[$lang].landing.stats.stat3.title,
        quantity:
          data.tasksInProgress +
          " " +
          $conversion[$lang].landing.stats.stat3.title,
        txt: $conversion[$lang].landing.stats.stat3.description,
        bgcolor: "#2C8F73",
        color: "#FFFFFF",
      },
    ];
  });

  /* SHOPIFY
	async function Charge(currentPackage){
		console.log(currentPackage)
		let rep = await fetch(baseAPIUrl + "/stripe/createCharge", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({price:currentPackage.price,success_url:baseAPIUrl+"/stripe/createRecordFirebase",cancel_url:"https://localhost:5001/"}),
        }).then((rep) => {
          return rep.json();
        });
		
		console.log(rep)
		window.open(rep.application_charge.confirmation_url, '_blank').focus();
		await $user.create.charge(rep.application_charge.id,{charge:rep.application_charge,hrs:currentPackage.hrs,name:currentPackage.name})


	}
	*/

  async function Charge(currentPackage) {
    console.log(currentPackage);
    let rep = await fetch(baseAPIUrl + "/stripe/createCharge", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        prod_id: currentPackage.prod_id,
        price: currentPackage.price,
        success_url: "http://localhost:5000/transaction-history",
        cancel_url: "https://localhost:5001/",
      }),
    }).then((rep) => {
      return rep.json();
    });

    console.log(rep);
    window.open(rep.url, "_blank").focus();
    let charge = {
      id: rep.id,
      hrs: currentPackage.hrs,
      name: currentPackage.name,
      status: false,
      type: "debit",
    };
    await $user.create.charge(rep.id, {
      charge: charge,
      currentHrs: data.availableHrs,
    });
  }
</script>

<div
  in:fade={{ duration: 300, delay: 300 }}
  out:fade={{ duration: 300, delay: 0 }}
  class="wrapper"
>
  <!--Hours remaining-->
  <div class="stat-wrapper">
    {#each info as nf}
      <div
        style="background-color:{nf.bgcolor};color:{nf.color}"
        class="stat-ctn"
      >
        <div class="stat-hrs">{nf.quantity}</div>
        <div class="stat-txt">{nf.txt}</div>
      </div>
    {/each}
  </div>
  <div class="description-wrapper">
    <div class="img">👋</div>
    <div class="flex-column">
      <div class="description-txt bold">
        {$conversion[$lang].landing.descriptionSection.title}
      </div>
      <div class="description-txt">
        {$conversion[$lang].landing.descriptionSection.subTitle}
      </div>

      <!-- <a href="#a" class="description-txt btn"
        >{$conversion[$lang].landing.descriptionSection.button}</a
      > -->
    </div>
  </div>
  <!--
  <div class="video">
    <iframe
      width="100%"
      height="500"
      src="https://www.youtube.com/embed/UalTfOIDQ7M"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </div>
  -->
  <!-- <div class="small-title">{$conversion[$lang].landing.pricing.label}</div>
	<div class="pricing-title">{$conversion[$lang].landing.pricing.title}</div>
	<div class="pricing-txt">
		{$conversion[$lang].landing.pricing.description}
	</div>
	<div class="packages-wrapper">
		{#each Packages as Package}
			<div class="package-ctn">
				<div
					style="background-color:{Package.ctnColor}"
					class="package-line" />
				<div class="package-title">{Package.name}</div>
				<div style="color:{Package.hrsColor}" class="package-hrs">
					{Package.hrs}
					{$conversion[$lang].landing.pricing.packages.package1.quantity}
				</div>
				<div class="package-price">{Package.price}$</div>
				<div class="package-desc">{Package.desc}</div>
				<a
					on:click={() => {
						Charge(Package);
					}}
					href="#B"
					style="background-color:{Package.startbgColor};border:2px solid {Package.startborderColor}"
					class="get-started-ctn">
					<div
						style="color:{Package.startColor}"
						class="get-started-txt">
						{$conversion[$lang].landing.pricing.packages.package1.button}
					</div>
					<div
						style="color:{Package.startColor};display: flex;"
						class="get-started-img">
						<i
							style="font-weight: 600;font-size:1.1em"
							class="bx bx-right-arrow-alt" />
					</div>
				</a>
			</div>
		{/each}
	</div> -->
</div>

<style>
  .stat-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 4.5rem;
    margin-bottom: 3.5rem;
    width: 100%;
  }

  .stat-ctn {
    padding: 2rem 2.5rem;
    display: flex;
    flex-direction: column;
    border-radius: 19px;
    width: 100%;
    margin: 0 10px;
    min-width: max-content;
  }
  .stat-hrs {
    font-size: 2.925em;
    font-family: Inter;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .stat-txt {
    font-size: 1.1em;
    font-weight: 300;
    font-family: Inter;
  }

  .wrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 95%;
    max-width: 1190px;
  }

  .description-wrapper {
    display: flex;
    align-items: flex-start;
    padding: 1.5rem;
    background-color: white;
    color: black;
    box-shadow: 0px 6px 58px rgba(121, 145, 173, 0.195504);
    border: 1px solid #d8e0f0;
    border-radius: 16px;
    margin-bottom: 2rem;
    width: 100%;
    box-sizing: border-box;
  }

  .img {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.6rem 0.8rem;
    font-size: 1.5em;
    margin-right: 1rem;
    border-radius: 50%;
    background-color: #e4ecf7;
  }

  .flex-column {
    padding-top: 1rem;
    display: flex;
    flex-direction: column;
  }

  .description-txt {
    font-size: 1em;
    color: black;
    font-weight: 500;
    margin-bottom: 0.8rem;
  }

  .bold {
    font-weight: 600;
  }

  .btn {
    padding: 0.5rem 1.5rem;
    background: white;
    border-radius: 14px;
    border: 1px solid #d8e0f0;
    cursor: pointer;
    margin: 0;
    width: fit-content;
  }
  .video {
    width: 100%;
    border-radius: 26px;
    overflow: hidden;
    margin-bottom: 3.5rem;
  }

  .small-title {
    padding: 0.5rem 0.75rem;
    background-color: #e3f0ec;
    border-radius: 20px;
    color: #36b37e;
    font-size: 0.875em;
    font-weight: 600;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .pricing-title {
    text-align: center;
    letter-spacing: 0.2px;
    font-size: 2.25em;
    font-weight: 600;
    color: #183b56;
    margin: 1rem 0;
    width: 45%;
  }

  .pricing-txt {
    font-size: 1.125em;
    font-weight: 400;
    text-align: center;
    color: #5a7084;
    width: 60%;
  }

  .packages-wrapper {
    display: flex;
    justify-content: space-between;
    margin: 4rem 0;
    width: 100%;
  }

  .package-ctn {
    background-color: white;
    padding: 3rem 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 25%;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
  }

  .package-line {
    position: absolute;
    height: 3px;
    width: 100%;
    top: 0;
    left: 0;
  }

  .package-title {
    font-weight: 600;
    letter-spacing: 0.2px;
    font-size: 1.5em;
    color: #183b56;
    margin-bottom: 1.5rem;
  }

  .package-hrs {
    font-weight: 600;
    letter-spacing: 0.2px;
    font-size: 2.5em;
  }

  .package-price {
    font-weight: 600;
    letter-spacing: 0.2px;
    font-size: 1.25em;
    color: #2e294e;
    margin-bottom: 1.5rem;
    margin-top: -0.25rem;
  }

  .package-desc {
    font-weight: 400;
    letter-spacing: 0.2px;
    line-height: 26px;
    font-size: 1em;
    color: #5a7084;
    margin-bottom: 3rem;
  }

  .get-started-ctn {
    display: flex;
    padding: 0.5rem 1.15rem;
    border-radius: 22px;
    align-items: center;
  }

  .get-started-txt {
    font-size: 1em;
    font-weight: 600;
    margin-right: 0.2rem;
  }

  @media only screen and (max-width: 1100px) {
    .stat-wrapper {
      flex-direction: column;
    }
    .stat-ctn {
      margin: 10px 0;
    }
  }
</style>
